import { ApolloError, useQuery } from '@apollo/client';

import { isDemoEnvironment } from '../../../constants/global';
import { handleGql403 } from '../../../utils';
import { GetOrganizationsByUserQuery, GetOrganizationsByUserQueryVariables, Organization } from '../types';
import { mockOrganization } from './mock';
import { GET_ORGANIZATIONS_BY_USER } from './organizationsByUser';

export type OrganizationResponse = {
  data?: Organization[];
  loading: boolean;
  error?: ApolloError;
};

const useFetchOrganizationsByUser = (): OrganizationResponse => {
  const { data, loading, error } = useQuery<GetOrganizationsByUserQuery, GetOrganizationsByUserQueryVariables>(
    GET_ORGANIZATIONS_BY_USER,
    { onError: handleGql403, skip: isDemoEnvironment }
  );

  if (isDemoEnvironment) {
    return {
      loading: false,
      data: [mockOrganization],
    };
  }

  return {
    data: data?.organizationsByUser as Organization[],
    loading,
    error,
  };
};

export default useFetchOrganizationsByUser;
